import Controller from 'controllers/controller';
import TabsController from 'controllers/components/tabs';
import Elements from 'tools/elements';

/**
 * @class TabsComponentsController - This class finds all tabs components on the page and instantiates TabsController
 * classes for each.
 */
class TabsComponentsController extends Controller {
    ready() {
        this.elements = new Elements;
        
        // Store instances and elements seperately, so that we may find the equivalent instance via the index of the
        // tabs element, and vice versa.
        this.tabsInstances = [ ];
        this.tabsElements = [ ];
        
        this.findNewGalleries();
    }
    
    attachEvents() {
        this.app.on('dom-change', this.findNewGalleries);
    }

    findNewGalleries() {
        this.cacheElements();
        this.initControllers();
    }
    
    cacheElements() {
        this.elements.queryAll('tabs', '.tabs');
    }
    
    getInstance(tabsElement) {
        let index = this.tabsElements.indexOf(tabsElement);
        
        return this.tabsInstances[index] || null;
    }
    
    initControllers() {
        this.elements.each('tabs', tabs => {
            let instance = this.getInstance(tabs);
            
            // Don't double instantiate
            if (instance) {
                return;
            }
            
            this.tabsElements.push(
                tabs
            );
            
            this.tabsInstances.push(
                this.app.make(TabsController, tabs)
            );
        })
    }
}

export default TabsComponentsController;


// WEBPACK FOOTER //
// ./site/templates/resources/src/js/controllers/tabs-components.js